import { render, staticRenderFns } from "./purchases-view.vue?vue&type=template&id=626b39e2&scoped=true&lang=pug"
import script from "./purchases-view.js?vue&type=script&lang=js&external"
export * from "./purchases-view.js?vue&type=script&lang=js&external"
import style0 from "./purchases-view.vue?vue&type=style&index=0&id=626b39e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b39e2",
  null
  
)

export default component.exports